import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-email-avatar',
  template: `
    <div class="email-avatars-container">
      <div 
        *ngFor="let assignment of assignments?.items?.slice(0, 3); let i = index" 
        class="email-avatar"
        [style.background-color]="getBackgroundColor(assignment.email, i)"
        [matTooltip]="assignment.email"
        matTooltipPosition="above"
      >
        {{ assignment.email[0].toUpperCase() }}
      </div>
      <div 
        *ngIf="assignments?.items?.length > 3" 
        class="email-avatar more-avatar"
        [matTooltip]="getMoreEmails()"
        matTooltipPosition="above"
      >
        +{{ assignments.items.length - 3 }}
      </div>
    </div>
  `,
  styles: [`
    .email-avatars-container {
      position: absolute;
      bottom: 8px;
      right: 8px;
      display: flex;
      gap: 4px;
      z-index: 1;
    }

    .email-avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 500;
      border: 2px solid white;
      cursor: default;
    }

    .more-avatar {
      background-color: #F5F5F5 !important;
      color: rgba(0, 0, 0, 0.6);
    }
  `]
})
export class EmailAvatarComponent {
  @Input() assignments: any;

  private colors = [
    '#1E88E5', // Blue
    '#43A047', // Green
    '#E53935', // Red
    '#FB8C00', // Orange
    '#8E24AA', // Purple
    '#00ACC1', // Cyan
    '#3949AB', // Indigo
    '#7CB342', // Light Green
    '#C0CA33', // Lime
    '#FFB300', // Amber
    '#00897B', // Teal
    '#F4511E', // Deep Orange
    '#5E35B1', // Deep Purple
    '#1565C0', // Blue
    '#2E7D32', // Green
    '#D81B60', // Pink
  ];

  getBackgroundColor(email: string, index: number): string {
    // Use both first and second characters plus index to generate color
    const firstChar = email[0].toLowerCase().charCodeAt(0);
    const secondChar = email[1]?.toLowerCase().charCodeAt(0) || 0;
    const colorIndex = (firstChar + secondChar + index) % this.colors.length;
    return this.colors[colorIndex];
  }

  getMoreEmails(): string {
    return this.assignments.items
      .slice(3)
      .map((a: any) => a.email)
      .join('\n');
  }
} 